import { Component, OnInit, HostBinding } from '@angular/core';
import { CommonService } from '../../../../services/common/common.service';
import { RestService } from '../../../../services/rest/rest.service';
import { Endpoint, HelpIndex } from '../../../../models/enums';
import { SelectSystemStorageDepotModalComponent } from '../../select-system-storage-depot-modal/select-system-storage-depot-modal.component';
import { ObjectActionListType, ActionType, Permissions } from '../../../../models/permission';

@Component({
    standalone: false,
    selector: 'res-system-storage-depot',
    templateUrl: './system-storage-depot.component.html',
    styleUrls: ['./system-storage-depot.component.scss']
})
export class SystemStorageDepotComponent implements OnInit {
    @HostBinding('class') classes = 'maximized-component';
    automationId = 'system-storage-depot';
    newStorageSystemSelected = true;
    isBusy = true;
    systemStorageDepotExists = false;
    systemStorageDepot: any = {};
    hasCreatePermissions: boolean;

    constructor(private restService: RestService,
        private commonService: CommonService) { }

    ngOnInit(): void {
        this.restService.post(Endpoint.realmManager_getSystemStorageDepot, { systemScope: true }).then((storageDepotResponse) => {
            this.isBusy = false;
            if (storageDepotResponse?.systemStorageDepotDto?.depotName && storageDepotResponse?.systemStorageDepotDto?.directoryPath) {
                this.systemStorageDepotExists = true;
                this.systemStorageDepot.depotName = storageDepotResponse.systemStorageDepotDto.depotName;
                this.systemStorageDepot.directoryPath = storageDepotResponse.systemStorageDepotDto.directoryPath;
            }
            this.hasCreatePermissions = Permissions.checkUserPermission(ObjectActionListType.SYSTEM_STORAGE, ActionType.CREATE);
        }, () => {
            this.isBusy = false;
        });
    }

    openHelp = () => this.commonService.openHelp(HelpIndex.sys_set_system_storage_depot_dlg);

    openSelectSystemStorageDepotModalPopup() {
        this.commonService.openModal(SelectSystemStorageDepotModalComponent, {
            backdrop: false, keyboard: false,
            class: 'vertical-px-600 horizontal-px-1200'
        }).then(response => {
            if (response?.modalData?.depotName && response?.modalData?.directoryPath) {
                this.systemStorageDepotExists = true;
                this.systemStorageDepot.depotName = response.modalData.depotName;
                this.systemStorageDepot.directoryPath = response.modalData.directoryPath;
            }
        }, () => { this.isBusy = false; });
    }
}
